/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	ExpiresIn: null, //Thời gian hết hạn của token
	AuthorizedAt: null, //Thời điểm đăng nhập thành công
	AccessToken: null, //AccessToken
	TokenType: null, //Loại token
	RefreshToken: null, //RefreshToken
	User: null //Thông tin user
};
